const preventKeysOnNumberInput = (event) => {
  const { key } = event;
  //   const key = event.which ? event.which : event.keyCode;
  if (key === '-' || key === '+' || key === 'e') {
    event.preventDefault();
  }
};

export default preventKeysOnNumberInput;
